import { i18n } from '@lingui/core';
import { detect, fromNavigator, fromStorage, fromUrl } from '@lingui/detect-locale';

export const locales = {
  en: 'English',
  cs: 'Čeština',
} as const;

export type Locale = keyof typeof locales;
export const defaultLocale: Locale = 'en';

const STORAGE_KEY = 'app-locale';

/**
 * Dynamically load and activate a locale catalog.
 * Only the requested locale is loaded, creating a separate JS chunk.
 */
export async function loadLocale(locale: Locale): Promise<void> {
  const { messages } = await import(`../locales/${locale}/messages.po`);
  i18n.loadAndActivate({ locale, messages });
  localStorage.setItem(STORAGE_KEY, locale);
}

/**
 * Detect user's preferred locale from storage, URL, or browser settings.
 * Falls back to defaultLocale if detected locale is not supported.
 */
export function detectLocale(): Locale {
  const detected = detect(fromStorage(STORAGE_KEY), fromUrl('lang'), fromNavigator(), () => defaultLocale);

  return locales[detected as Locale] ? (detected as Locale) : defaultLocale;
}

// Export the i18n instance for direct access if needed
export { i18n };
